import React from 'react';
import PropTypes from 'prop-types';
import Box from '@material-ui/core/Box';
import Link from '@material-ui/core/Link';
import Typography from '@material-ui/core/Typography';
import OpenInNewIcon from '@material-ui/icons/OpenInNew';
import { getDeprecationWarningBannerMessage } from '../constants/infohubBannerCopy';
import { useLeavingSoonBannerCopyFlag } from '../hooks/useGetFeatureFlag';
import getInfoHubUrl from '../utils/get-infohub-url';

const BannerText = ({ title, infohubUrl }) => {
  const useNewCopy = useLeavingSoonBannerCopyFlag();
  const textStyle = {
    fontWeight: 'bold',
    textAlign: 'center',
    fontSize: '14px',
    color: 'black',
  };
  const linkStyle = { color: 'black', textDecoration: 'none' };
  const url = infohubUrl || getInfoHubUrl();
  const message = getDeprecationWarningBannerMessage(title, useNewCopy);

  return (
    <Link href={url} target="_blank" rel="noopener noreferrer" style={linkStyle}>
      <Typography variant="body1" component="div" sx={textStyle}>
        {message} <OpenInNewIcon style={{ fontSize: '14px', verticalAlign: 'middle', marginLeft: '4px' }} />
      </Typography>
    </Link>
  );
};

BannerText.propTypes = {
  title: PropTypes.string.isRequired,
  infohubUrl: PropTypes.string,
};

const DeprecationWarningBanner = ({ title, infohubUrl }) => (
  <Box
    sx={{
      backgroundColor: '#fff3cd',
      border: '1px solid #ffc107',
      padding: '12px 16px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
      borderRadius: '8px',
      marginBottom: '16px',
    }}
  >
    <BannerText title={title} infohubUrl={infohubUrl} />
  </Box>
);

DeprecationWarningBanner.propTypes = {
  title: PropTypes.string.isRequired,
  infohubUrl: PropTypes.string,
};

export default DeprecationWarningBanner;
